import React, { useEffect, useRef, useState } from "react";
import { data, useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import PropertyReqFileds from "../../components/Property/PropertyReqFileds";
import moment from "moment";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { checkPermission } from "../../screen/redux/api/PermissionManager";

const Rejected = ({
  ownersList,
  pagination,
  setIsUpdate,
  reSend,
  setIsRejectList,
  page,
  setPage,
}) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  // const [page, setPage] = useState(1);
  // const [pagination, setPagination] = useState("");
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [popup, setPopup] = useState(false);

  const [owners, setOwners] = useState([]);

  const handleImageClick = () => {
    inputRef.current.click();
  };
  const handleStatus = ({ id }) => {
    const updatedData = [...owners]; // Create a copy of the data
    const currentStatus = updatedData[id].status || "on"; // Default to "on" if undefined

    updatedData[id].status = currentStatus === "on" ? "off" : "on";
    setOwners(updatedData);
    console.log("KK", id);
    // let value = data.filter((ele, i) => i == id ? ele.status == "off" ? "on" : "off")
  };

  const users = [
    { id: 1, name: "Chennai", age: 28, city: "New York" },
    { id: 2, name: "Banglore", age: 34, city: "Los Angeles" },
    { id: 3, name: "Hyderabad", age: 22, city: "Chicago" },
    { id: 4, name: "Nellore", age: 25, city: "Miami" },
    { id: 5, name: "Guntur", age: 40, city: "San Francisco" },
  ];
  const ownerList = [
    { id: 1, name: "John Doe", age: 28, city: "New York" },
    { id: 2, name: "Jane Smith", age: 34, city: "Los Angeles" },
    { id: 3, name: "Sam Brown", age: 22, city: "Chicago" },
    { id: 4, name: "Emily Johnson", age: 25, city: "Miami" },
    { id: 5, name: "Michael Davis", age: 40, city: "San Francisco" },
  ];
  const options = users.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });
  const ownerOptions = ownerList.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });

  // const columns = React.useMemo(
  //   () => [
  //     {
  //       Header: "S.No",
  //       accessor: "",
  //       Cell: ({ value, row }) => {
  //         return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
  //       },
  //     },
  //     {
  //       Header: "User",
  //       accessor: "user",
  //       Cell: ({ value, row }) => {
  //         return <p className="primary pointer">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: " Booking ID",
  //       accessor: "Bookingid",
  //       Cell: ({ value, row }) => {
  //         return <p>{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "State",
  //       accessor: "state",
  //       Cell: ({ value, row }) => {
  //         return <p>{value}</p>;
  //       },
  //     },
  //     {
  //       Header: " City",
  //       accessor: "city",
  //       Cell: ({ value, row }) => {
  //         return <p>{value}</p>;
  //       },
  //     },

  //     {
  //       Header: "Wallet Amount",
  //       accessor: "Wallet",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "Generated Date",
  //       accessor: "GeneratedDate",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "Requested by",
  //       accessor: "Requestedby",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "Date",
  //       accessor: "Date",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //       {
  //       Header: "Status",
  //       accessor: "status",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}(i)</p>;
  //       },
  //     },

  //     {
  //       Header: "Action",
  //       accessor: "",
  //       Cell: ({ value, row }) => {
  //         return (
  //           <React.Fragment>
  //             <div className="d-flex ac-js gap-3">
  //               <button
  //                 onClick={() => {
  //                   navigate("/wallettransactionadd", { state: { type: "view" } });
  //                 }}
  //                 className="cust-btn "
  //               >
  //                 <img src={view_icon} alt="" className=" edit-btn " />
  //               </button>

  //                  <button
  //                     type="submit"
  //                     className="resend-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
  //                     onClick={() => {
  //   navigate("/wallettransaction", { state: { type: "requested" } });
  // }}
  //                   >
  //                     Resend
  //                   </button>
  //             </div>
  //           </React.Fragment>
  //         );
  //       },
  //     },
  //   ],
  //   []
  // );
  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Ticket ID",
        accessor: "ticket_id",
        accessorFn: (row) => row.ticket_transaction?.ticket,

        Cell: ({ value, row }) => {
          return (
            <p className="primary pointer">
              {row?.original?.ticket_transaction?.ticket || "-"}
            </p>
          );
        },
      },
      {
        Header: "User",
        accessor: "user_name",
        Cell: ({ value, row }) => {
          return <p className="primary pointer">{value}</p>;
        },
      },
      {
        Header: " Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Wallet Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Generated Date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap">{moment(value).format("DD/MM/YYYY")}</p>
          );
        },
      },
      {
        Header: "Requested by",
        accessor: "requested_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Current status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value == 5 ? "Rejected" : ""}</p>;
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row }) => {
          console.log("DSASLDSAa", row?.original);

          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                {checkPermission("CAN-EDIT-WALLETUSER") && (
                  <button
                    onClick={() => {
                      navigate("/wallettransactionadd", {
                        state: {
                          type: "edit",
                          userDatas: row?.original,
                          setReject: true,
                        },
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-VIEW-WALLETUSER") && (
                  <button
                    onClick={() => {
                      setIsRejectList({
                        data: row?.original?.ticket_transaction?.id,
                        isViewList: true,
                        ticket_id: row?.original,
                      });
                    }}
                    className="cust-btn "
                  >
                    <img src={view_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-EDIT-WALLETUSER") && (
                  <button
                    type="button"
                    className="resend-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 "
                    onClick={() => {
                      reSend(row?.original);
                      // navigate("/wallettransaction", {
                      //   state: { type: "requested" },
                      // });
                    }}
                  >
                    Resend
                  </button>
                )}

                {/* <button onClick={() => setPopup(true)} className="cust-btn ">
                  <img src={delete_icon} alt="" className=" edit-btn " />
                </button> */}
                {/* <input
                  type="checkbox"
                  checked={row.original.selected}
                  onChange={() => handleCheckboxToggle(row?.original?.id)}
                /> */}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page]
  );
  useEffect(() => {
    setOwners(ownersList);
  }, [ownersList]);
  return (
    <div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rejected;
